// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/NoteItem/index.css
// module id = 1904
// module chunks = 0